// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
// содержит определение,
import { RiskPlanItem } from './RiskPlanItem';
// к какой группе инструментов применить указанный план
export class RiskPlanData {
    constructor() {
        this.Item = new RiskPlanItem();
        this.RiskPlanDataKey = null;
    }
    toString() {
        return 'TODO. RiskPlanData.prototype.toString';
    }
}
